import { render, staticRenderFns } from "./ExperimentCreate.vue?vue&type=template&id=8926217c&"
import script from "./ExperimentCreate.vue?vue&type=script&lang=js&"
export * from "./ExperimentCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports